import React from 'react';

import { Box, Paper, PaperProps, BoxProps } from '@material-ui/core';

import { useStyles } from './styles';

interface ScaffolderFormPaperProps {
  children: React.ReactNode;
  paperProps?: PaperProps;
  boxProps?: Omit<BoxProps, 'padding'>;
}

export const ScaffolderFormPaper = (props: ScaffolderFormPaperProps) => {
  const { children, paperProps, boxProps } = props;

  const classes = useStyles();

  return (
    <Box className={classes.formPaperContainer} {...boxProps}>
      <Paper className={classes.formPaper} {...paperProps}>
        <Box className={classes.formPaperChildContainer}>{children}</Box>
      </Paper>
    </Box>
  );
};
